import { render, staticRenderFns } from "./JdsTeleportProvider.vue?vue&type=template&id=881a3db4&scoped=true&"
import script from "./JdsTeleportProvider.vue?vue&type=script&lang=ts&"
export * from "./JdsTeleportProvider.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "881a3db4",
  null
  
)

export default component.exports